import { rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.cross.arancin};
  padding: ${rem('16px')};
  border-radius: ${rem('8px')};
  align-items: center;
`;

export const StyledText = styled.div`
  color: ${({ theme }) => theme.colors.cross.arancin};
  font-size: ${rem('12px')};
  font-weight: 600;
`;

export const StyledInfoWrapper = styled.div`
  margin-right: ${rem('16px')};
  display: flex;
`;
